var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.vueAppClasses,attrs:{"id":"app"}},[_c('router-view',{on:{"setAppClasses":_vm.setAppClasses}})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }